import { clamp, random } from './utils';
import jsx from './jsx';

let frameRate = 24;
let timeBeforeEnd = 2;
const images: string[] = [
  'https://assets.pfy.ch/og/000000400002.jpg',
  'https://assets.pfy.ch/og/000000410016.jpg',
  'https://assets.pfy.ch/og/000000410018.jpg',
  'https://assets.pfy.ch/og/000000410023.jpg',
  'https://assets.pfy.ch/og/000000410032.jpg',
  'https://assets.pfy.ch/og/000002030012.jpg',
  'https://assets.pfy.ch/og/000002030014.jpg',
  'https://assets.pfy.ch/og/000002040011.jpg',
  'https://assets.pfy.ch/og/000002040036.jpg',
  'https://assets.pfy.ch/og/000005590036.jpg',
  'https://assets.pfy.ch/og/000005600011.jpg',
  'https://assets.pfy.ch/og/000030050013.jpg',
  'https://assets.pfy.ch/og/000030050014.jpg',
  'https://assets.pfy.ch/og/000030050017.jpg',
  'https://assets.pfy.ch/og/000030050028.jpg',
  'https://assets.pfy.ch/og/000038520014.jpg',
  'https://assets.pfy.ch/og/000038520020.jpg',
  'https://assets.pfy.ch/og/000092310004.jpg',
  'https://assets.pfy.ch/og/000092310018.jpg',
  'https://assets.pfy.ch/og/A002110-R1-09-10.JPG',
  'https://assets.pfy.ch/og/A005698-R1-00-24A.JPG',
  'https://assets.pfy.ch/og/A005698-R1-12-12A.JPG',
  'https://assets.pfy.ch/og/CRO0022-R1-11-12.JPG',
  'https://assets.pfy.ch/og/CRO0169-R1-24-12A.JPG',
  'https://assets.pfy.ch/og/CRO0169-R1-25-11A-retouched.jpg',
  'https://assets.pfy.ch/og/CRO0543-R1-11-10.JPG',
  'https://assets.pfy.ch/og/CRO0579-R1-07-8A.JPG',
  'https://assets.pfy.ch/og/CRO0579-R1-11-12A.JPG',
  'https://assets.pfy.ch/og/CRO0579-R1-18-19A.JPG',
  'https://assets.pfy.ch/og/CRO0579-R1-32-33A.JPG',
  'https://assets.pfy.ch/og/CRO1678-R1-04-32A.JPG',
  'https://assets.pfy.ch/og/CRO1678-R1-07-29A.JPG',
  'https://assets.pfy.ch/og/CRO1679-R1-29-7A.JPG',
  'https://assets.pfy.ch/og/CRO1995-R1-18-6.JPG',
  'https://assets.pfy.ch/og/CRO2647-R1-00-36.JPG',
  'https://assets.pfy.ch/og/CRO2647-R1-07-29.JPG',
  'https://assets.pfy.ch/og/CRO2648-R1-02-35A.JPG',
  'https://assets.pfy.ch/og/CRO2648-R1-20-17A.JPG',
  'https://assets.pfy.ch/og/CRO2648-R1-31-6A.JPG',
  'https://assets.pfy.ch/og/CRO2648-R1-33-4A.JPG',
  'https://assets.pfy.ch/og/CRO2648-R1-35-2A.JPG',
  'https://assets.pfy.ch/og/CRO2698-R1-06-18A.JPG',
  'https://assets.pfy.ch/og/CRO2871-R1-10-14A.JPG',
  'https://assets.pfy.ch/og/CRO2871-R1-22-2A.JPG',
  'https://assets.pfy.ch/og/CRO3326-R1-02-22A.JPG',
  'https://assets.pfy.ch/og/CRO3326-R1-16-8A.JPG',
  'https://assets.pfy.ch/og/CRO3326-R1-18-6A.JPG',
  'https://assets.pfy.ch/og/CRO3326-R1-21-3A.JPG',
  'https://assets.pfy.ch/og/CRO3326-R1-22-2A.JPG',
  'https://assets.pfy.ch/og/CRO3745-R1-09-15A.JPG',
  'https://assets.pfy.ch/og/CRO3745-R1-12-12A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-05-31A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-07-29A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-11-25A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-18-18A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-34-2A.JPG',
  'https://assets.pfy.ch/og/CRO6452-R1-35-1A.JPG',
  'https://assets.pfy.ch/og/CRO7506-R1-10-14A.JPG',
  'https://assets.pfy.ch/og/CRO7506-R1-23-1A.JPG',
  'https://assets.pfy.ch/og/CRO0831-R1-22-24.png',
  'https://assets.pfy.ch/og/CRO7506-R1-23-1A.JPG',
  'https://assets.pfy.ch/og/CRO7506-R1-22-2A.JPG',
  'https://assets.pfy.ch/og/DSCF0076.JPG',
];

let target: HTMLDivElement;
let loadingBar: HTMLDivElement;
let progress = 0;

let now = performance.now();
let finish = performance.now() + timeBeforeEnd * 1000;
let then = performance.now();
let frameInterval = 1000 / frameRate;
let lastRandom = 0;

const uniqueRandom = (): number => {
  let newRandom = random(0, images.length - 1);

  if (newRandom === lastRandom) {
    return uniqueRandom();
  }

  lastRandom = newRandom;

  return newRandom;
};

export let elapsed = 0;
const render = async (newTime: number) => {
  now = newTime;
  elapsed = now - then;

  if (elapsed > frameInterval) {
    then = now - (elapsed % frameInterval);
    const images = [...target.querySelectorAll('img')];
    let current = uniqueRandom();

    if (images) {
      const percentComplete = Math.floor((now / finish) * 100);
      const grayscale = clamp(percentComplete, 100, 0);
      const saturate = clamp(300 * (percentComplete / 100), 400, 0);
      const opacity = clamp(100 - percentComplete, 100, 1);

      images.forEach((image, index) => {
        image.setAttribute(
          'style',
          `filter: grayscale(${grayscale}%) saturate(${100 + saturate}%); opacity: ${opacity}%;`,
        );
        if (index === current) {
          image.className = '';
        } else {
          image.className = 'hidden';
        }
      });
    }
  }

  requestAnimationFrame(render);
};

const preRender = () => {
  if (progress === images.length) {
    finish = performance.now() + timeBeforeEnd * 1000;
    target.className = 'loaded';

    target.appendChild(<h1>Do you remember?</h1>);
    target.appendChild(
      <p>
        A point in the distance, fading.{'\n'}Nervousness sets in.{'\n'}Fear of
        the unknown.{'\n'}It's all happened before.{'\n'}But you dont remember.
        {'\n'}I'm so, so sorry.
      </p>,
    );

    requestAnimationFrame(render);
  }
};

const handleImageLoaded = () => {
  progress += 1;
  loadingBar.style.width = `${(progress / images.length) * 100}%`;
  preRender();
};

const audio = () => {
  const audioCtx = new AudioContext();

  const chord = [220.5, 138.5, 164.5];

  const oscillators = chord.map((note) => {
    const oscillator = audioCtx.createOscillator();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(note, audioCtx.currentTime); // value in hertz
    return oscillator;
  });

  const gainNode = audioCtx.createGain();

  setInterval(() => {
    const fade = audioCtx.createGain();

    const drum = audioCtx.createOscillator();
    drum.type = 'square';
    drum.frequency.setValueAtTime(chord[0], audioCtx.currentTime);
    drum.connect(fade);
    drum.start();

    fade.gain.setValueAtTime(0.075, audioCtx.currentTime);
    fade.connect(gainNode);

    setTimeout(() => {
      drum.stop();
    }, 100);
  }, 1000);

  oscillators.forEach((oscillator) => {
    oscillator.connect(gainNode);

    oscillator.start();
  });

  gainNode.gain.setValueAtTime(0.05, audioCtx.currentTime);
  gainNode.connect(audioCtx.destination);
};

const loadImages = () => {
  audio();

  const loadingWrapper = <div className="loading"></div>;
  loadingBar = (<div className="loadingBar"></div>) as HTMLDivElement;
  loadingWrapper.appendChild(loadingBar);
  target = document.getElementById('target') as HTMLDivElement;

  if (target) {
    target.appendChild(loadingWrapper);
    images.forEach((image) => {
      const element = (
        <img
          src={image}
          onLoad={handleImageLoaded}
          onError={() => console.error(`${image} failed to load`)}
        />
      ) as HTMLImageElement;

      target.appendChild(element);
    });
  } else {
    console.error('Missing target element');
  }
};

const tillClose = () => {
  const now = Date.now();
  const closingTime = new Date();
  const closingHourInput = document.getElementById(
    'closeHours',
  ) as HTMLInputElement;

  closingTime.setHours(parseInt(closingHourInput.value || '17'), 0, 0, 0);

  const msDiff = closingTime.valueOf() - now;
  const secDiff = msDiff / 1000;
  const minDiff = Math.max(Math.floor(secDiff / 60), 0);

  console.log(minDiff);

  frameInterval = 1000 / 24;
  timeBeforeEnd = minDiff * 60;

  loadImages();
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .getElementById('options')
    ?.addEventListener('submit', function (event) {
      event.preventDefault();

      const formData = new FormData(event.target as HTMLFormElement);
      const data = Object.fromEntries(formData);

      console.log(data);

      frameInterval = 1000 / parseFloat(data.framerate as unknown as string);
      timeBeforeEnd = parseFloat(data.minutes as unknown as string) * 60;

      loadImages();
    });

  // @ts-ignore - window assignment cause lazy non form buttons
  window.tillClose = tillClose;
});
